/**
 * Import CSS
 */
import './capture.css';

import {baseConfig, exhibitionConfig, lang} from '/main';

/**
 * Import 3rd party classes
 */
import html2canvas from 'html2canvas';

/**
 * Captures the current frame and clones it into another canvas for saving as image
 * @param {boolean} print
 */
export function printScreen(print) {
  let captureButton = document.getElementById('printOffer');

  captureButton.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i> ' + lang['buttonPrintHallPlan'];
  let screenshotModal = document.getElementById('control-screenshot');

  html2canvas(document.body, {
    onclone: (element) => {
      if (print === true) {
        preparePrintModal(element);
      } else {
        prepareScreenModal(element);
      }
    }}).then((canvas) => {
    captureButton.innerHTML = '<i class="fas fa-print"></i> ' + lang['buttonPrintHallPlan'];

    document.getElementById('screenshot').appendChild(canvas);
    screenshotModal.style.display = 'block';

    if (print === true) {
      setTimeout(() => {
        window.print();
      }, 1000);
    }

    let closeButton = document.getElementById('screenshotClose');

    /**
     * Remove canvas after modal is closed
     */
    closeButton.addEventListener('click', () => {
      document.getElementById('screenshot').removeChild(document.getElementById('screenshot').querySelector('canvas'));
      screenshotModal.style.display = '';
      document.getElementById('printStyle').remove();
      screenshotModal.removeChild(screenshotModal.querySelector('#printContainer'));
    }, {passive: true, once: true});
  }).catch((err) => {
    console.dir(err);
  });
}

/**
 * Alters the elements in the captured frame
 * @param {string} element
 */
function preparePrintModal(element) {
  let logo = document.createElement('div');

  if (logo !== null) {
    logo.style.background = 'rgb(255,255,255)';
    logo.style.position = 'absolute';
    logo.style.top = '.5em';
    logo.style.right = '.5em';
    logo.style.textAlign = 'center';
    logo.style.borderRadius = '3px';
    logo.style.padding = '15px';
    logo.innerHTML = '<img src="' + (typeof exhibitionConfig['core']['printImageLogo']['logoUrl'] !== 'undefined' ? exhibitionConfig['core']['printImageLogo']['logoUrl'] : null) + '" width="' +
      (typeof exhibitionConfig['core']['printImageLogo']['logoWidth'] !== 'undefined' ? exhibitionConfig['core']['printImageLogo']['logoWidth'] : null) +
      '" height="' +
      (typeof exhibitionConfig['core']['printImageLogo']['logoHeight'] !== 'undefined' ? exhibitionConfig['core']['printImageLogo']['logoHeight'] : null) +
      '">';
  }
  element.querySelector('#' + baseConfig['mapProperties']['containerId']) !== null ? element.querySelector('#' + baseConfig['mapProperties']['containerId']).appendChild(logo) : null;
  element.querySelector('.controls') !== null ? element.querySelector('.controls').classList.add('hideCapture') : null;
  element.querySelector('#navigatorButton') !== null ? element.querySelector('#navigatorButton').classList.add('hideCapture') : null;
  element.querySelector('.navigatorGuideText') !== null ? element.querySelector('.navigatorGuideText').classList.add('hideCapture') : null;
  element.querySelector('#selectBoxContainer') !== null ? element.querySelector('#selectBoxContainer').classList.add('hideCapture') : null;
  element.querySelector('#control-zoom') !== null ? element.querySelector('#control-zoom').classList.add('hideCapture') : null;
  element.querySelector('#control-rotation') !== null ? element.querySelector('#control-rotation').classList.add('hideCapture') : null;
  element.querySelector('#control-rotation-left') !== null ? element.querySelector('#control-rotation-left').classList.add('hideCapture') : null;
  element.querySelector('#control-rotation-right') !== null ? element.querySelector('#control-rotation-right').classList.add('hideCapture') : null;
  element.querySelector('#control-sidenav') !== null ? element.querySelector('#control-sidenav').classList.add('hideCapture') : null;
  element.querySelector('#legendCollapse') !== null ? element.querySelector('#legendCollapse').classList.add('hideCapture') : null;
  element.querySelector('#control-buttons') !== null ? element.querySelector('#control-buttons').classList.add('hideCapture') : null;
  element.querySelector('#control-capture') !== null ? element.querySelector('#control-capture').classList.add('hideCapture') : null;
  element.querySelector('#contextChevron') !== null ? element.querySelector('#contextChevron').classList.add('hideCapture') : null;
  element.querySelector('#control-legend') !== null ? element.querySelector('#control-legend').classList.add('hideCapture') : null;

  let boothNumber = element.querySelector('#contextLabel');
  if (boothNumber !== null) {
    boothNumber.style.fontSize = '20px';
    boothNumber.style.lineHeight = '54px';
  }
  element.getElementById('context-content-head') !== null ? element.getElementById('context-content-head').style.display = 'none' : null;
  element.querySelector('.navigatorContainer') !== null ? element.querySelector('.navigatorContainer').style.background = 'rgb(255,255,255)' : null;
  element.querySelector('.navigatorContainer') !== null ? element.querySelector('.navigatorContainer').appendChild(boothNumber) : null;

  let styleTag = document.createElement('link');
  styleTag.id = 'printStyle';
  styleTag.setAttribute('href', 'css/print.css');
  styleTag.setAttribute('rel', 'stylesheet');

  document.getElementsByTagName('head')[0].appendChild(styleTag);
  createPrintableCaption();
}

/**
 * Alters the elements in the captured frame
 * @param {string} element
 */
function prepareScreenModal(element) {
  let logo = document.createElement('div');
  if (logo !== null) {
    logo.style.background = 'rgb(255,255,255)';
    logo.style.position = 'absolute';
    logo.style.top = '.5em';
    logo.style.right = '.5em';
    logo.style.textAlign = 'center';
    logo.style.borderRadius = '3px';
    logo.style.padding = '15px';
    logo.innerHTML = '<img src="' +
      typeof exhibitionConfig['core']['screenshotImageLogo']['logoUrl'] !== 'undefined' ? exhibitionConfig['core']['screenshotImageLogo']['logoUrl'] : null +
      '" width="' +
      typeof exhibitionConfig['core']['screenshotImageLogo']['logoWidth'] !== 'undefined' ? exhibitionConfig['core']['screenshotImageLogo']['logoWidth'] : null +
      '" height="' +
      typeof exhibitionConfig['core']['screenshotImageLogo']['logoHeight'] !== 'undefined' ? exhibitionConfig['core']['screenshotImageLogo']['logoHeight'] : null +
      '">';
  }

  element.querySelector('#' + baseConfig['mapProperties']['containerId']) !== null ? element.querySelector('#' + baseConfig['mapProperties']['containerId']).appendChild(logo) : null;

  element.querySelector('#navigatorButton') !== null ? element.querySelector('#navigatorButton').classList.add('hideCapture') : null;
  element.querySelector('.navigatorGuideText') !== null ? element.querySelector('.navigatorGuideText').classList.add('hideCapture') : null;
  element.querySelector('#selectBoxContainer') !== null ? element.querySelector('#selectBoxContainer').classList.add('hideCapture') : null;
  element.querySelector('#control-zoom') !== null ? element.querySelector('#control-zoom').classList.add('hideCapture') : null;
  element.querySelector('#control-rotation') !== null ? element.querySelector('#control-rotation').classList.add('hideCapture') : null;
  element.querySelector('#control-rotation-left') !== null ? element.querySelector('#control-rotation-left').classList.add('hideCapture') : null;
  element.querySelector('#control-rotation-right') !== null ? element.querySelector('#control-rotation-right').classList.add('hideCapture') : null;
  element.querySelector('#control-sidenav') !== null ? element.querySelector('#control-sidenav').classList.add('hideCapture') : null;
  element.querySelector('#legendCollapse') !== null ? element.querySelector('#legendCollapse').classList.add('hideCapture') : null;
  element.querySelector('#control-buttons') !== null ? element.querySelector('#control-buttons').classList.add('hideCapture') : null;
  element.querySelector('#control-capture') !== null ? element.querySelector('#control-capture').classList.add('hideCapture') : null;
  element.querySelector('#contextChevron') !== null ? element.querySelector('#contextChevron').classList.add('hideCapture') : null;
  element.querySelector('#control-legend') !== null ? element.querySelector('#control-legend').classList.add('hideCapture') : null;

  let boothNumber = element.querySelector('#contextLabel');
  if (boothNumber !== null) {
    boothNumber.style.fontSize = '20px';
    boothNumber.style.lineHeight = '54px';
  }
  element.getElementById('context-content-head') !== null ? element.getElementById('context-content-head').style.display = 'none' : null;
  element.querySelector('.navigatorContainer') !== null ? element.querySelector('.navigatorContainer').style.background = 'rgb(255,255,255)' : null;
  element.querySelector('.navigatorContainer') !== null ? element.querySelector('.navigatorContainer').appendChild(boothNumber) : null;

  let styleTag = document.createElement('link');
  styleTag.id = 'printStyle';
  styleTag.setAttribute('href', 'css/print.css');
  styleTag.setAttribute('rel', 'stylesheet');

  document.getElementsByTagName('head')[0].appendChild(styleTag);
  createPrintableCaption();
}

/**
 * Create a div element in the capture div for printing information
 */
function createPrintableCaption() {
  /**
   * Long logo for portrait print
   * @type {HTMLImageElement}
   */
  let exhibitionLogoLongImg = document.createElement('img');
  exhibitionLogoLongImg.src = typeof exhibitionConfig['core']['printPortraitLogo']['logoUrl'] !== 'undefined' ? exhibitionConfig['core']['printPortraitLogo']['logoUrl'] : null;
  exhibitionLogoLongImg.width = typeof exhibitionConfig['core']['printPortraitLogo']['logoWidth'] !== 'undefined' ? exhibitionConfig['core']['printPortraitLogo']['logoWidth'] : null;
  exhibitionLogoLongImg.height = typeof exhibitionConfig['core']['printPortraitLogo']['logoHeight'] !== 'undefined' ? exhibitionConfig['core']['printPortraitLogo']['logoHeight'] : null;

  let exhibitionLogoLong = document.createElement('div');
  exhibitionLogoLong.className = 'exhibitorLogo';
  exhibitionLogoLong.id = 'exhibitorLogo';
  exhibitionLogoLong.appendChild(exhibitionLogoLongImg);

  /**
   * Short logo for landscape print
   * @type {HTMLImageElement}
   */
  let exhibitionLogoShortImg = document.createElement('img');
  exhibitionLogoShortImg.src = typeof exhibitionConfig['core']['printLandscapeLogo']['logoUrl'] !== 'undefined' ? exhibitionConfig['core']['printLandscapeLogo']['logoUrl'] : null;
  exhibitionLogoShortImg.width = typeof exhibitionConfig['core']['printLandscapeLogo']['logoWidth'] !== 'undefined' ? exhibitionConfig['core']['printLandscapeLogo']['logoWidth'] : null;
  exhibitionLogoShortImg.height = typeof exhibitionConfig['core']['printLandscapeLogo']['logoHeight'] !== 'undefined' ? exhibitionConfig['core']['printLandscapeLogo']['logoHeight'] : null;

  let exhibitionLogoShort = document.createElement('div');
  exhibitionLogoShort.className = 'exhibitorLogoShort';
  exhibitionLogoShort.id = 'exhibitorLogoShort';
  exhibitionLogoShort.appendChild(exhibitionLogoShortImg);

  let poweredBy = document.createElement('div');
  poweredBy.className = 'poweredBy';
  poweredBy.id = 'poweredBy';
  poweredBy.innerHTML = '<span class="name">' + lang['printPoweredBy'] + '</span> <i class="material-icons">&#xE53B;</i>';

  let header = document.createElement('div');
  header.className = 'header';
  header.id = 'header';
  header.innerHTML = lang['printPrintHeader'];

  let headerDate = document.createElement('div');
  headerDate.className = 'headerDate';
  headerDate.id = 'headerDate';

  let dateObject = new Date();
  let date_de = dateObject.toLocaleDateString('de-DE', {day: '2-digit', month: '2-digit', year: 'numeric'});
  let date = dateObject.toLocaleDateString('en-GB', {day: '2-digit', month: '2-digit', year: 'numeric'});
  let hour = dateObject.getHours() < 10 ? '0' + dateObject.getHours() : dateObject.getHours();
  let minute = dateObject.getMinutes() < 10 ? '0' + dateObject.getMinutes() : dateObject.getMinutes();

  if (lang['id'] === 'de') {
    headerDate.innerHTML = lang['printDateTime'].replace('{DATE}', date_de).replace('{HOUR}', hour).replace('{MINUTE}', minute);
  } else {
    headerDate.innerHTML = lang['printDateTime'].replace('{DATE}', date).replace('{HOUR}', hour).replace('{MINUTE}', minute);
  }

  let headerContainer = document.createElement('div');
  headerContainer.className = 'headerContainer';
  headerContainer.id = 'headerContainer';
  headerContainer.appendChild(header);
  headerContainer.appendChild(headerDate);

  /**
   * Booth number
   * @type {HTMLDivElement}
   */
  let boothTitle = document.createElement('div');
  boothTitle.className = 'infoTitle';
  boothTitle.id = 'boothTitle';
  boothTitle.innerHTML = lang['printProposedBooth'];

  let boothInfo = document.createElement('div');
  boothInfo.className = 'info';
  boothInfo.id = 'boothInfo';
  boothInfo.innerHTML = document.getElementById('contextLabel').innerText.substring(7);

  let booth = document.createElement('div');
  booth.className = 'infoRow';

  booth.appendChild(boothTitle);
  booth.appendChild(boothInfo);

  let contextEntries = document.getElementsByClassName('contentEntry');

  let firstContextEntry = contextEntries[0];

  /**
   * Exhibitor Name
   * @type {HTMLDivElement}
   */
  let exhibitorTitle = document.createElement('div');
  exhibitorTitle.className = 'infoTitle';
  exhibitorTitle.id = 'exhibitorTitle';
  exhibitorTitle.innerHTML = lang['printExhibitorName'];

  let exhibitorInfo = document.createElement('div');
  exhibitorInfo.className = 'info';
  exhibitorInfo.id = 'exhibitorInfo';
  if (firstContextEntry !== undefined) {
    exhibitorInfo.innerHTML = firstContextEntry.querySelector('.exhibitorName') !== null ? firstContextEntry.querySelector('.exhibitorName').innerText : null;
  }

  let exhibitor = document.createElement('div');
  exhibitor.className = 'infoRow';

  exhibitor.appendChild(exhibitorTitle);
  exhibitor.appendChild(exhibitorInfo);

  /**
   * Billing address
   * @type {HTMLDivElement}
   */
  let billingTitle = document.createElement('div');
  billingTitle.className = 'infoTitle';
  billingTitle.id = 'billingTitle';
  billingTitle.innerHTML = lang['printBillingAddress'];

  let billingInfo = document.createElement('div');
  billingInfo.className = 'info';
  billingInfo.id = 'billingInfo';
  if (firstContextEntry !== undefined) {
    billingInfo.innerHTML = firstContextEntry.querySelector('.exhibitorAddress') !== null ? firstContextEntry.querySelector('.exhibitorAddress').innerHTML : 'n/a';
  }

  let billing = document.createElement('div');
  billing.className = 'infoRow';

  billing.appendChild(billingTitle);
  billing.appendChild(billingInfo);

  /**
   * Exhibitor Type
   * @type {HTMLDivElement}
   */
  let exhibitorTypeTitle = document.createElement('div');
  exhibitorTypeTitle.className = 'infoTitle';
  exhibitorTypeTitle.id = 'exhibitorTypeTitle';
  exhibitorTypeTitle.innerHTML = lang['printExhibitorType'];

  let exhibitorTypeInfo = document.createElement('div');
  exhibitorTypeInfo.className = 'info';
  exhibitorTypeInfo.id = 'exhibitorTypeInfo';
  if (firstContextEntry !== undefined) {
    exhibitorTypeInfo.innerHTML = firstContextEntry.querySelector('.exhibitorType') !== null ? firstContextEntry.querySelector('.exhibitorType').innerText : 'n/a';
  }

  let exhibitorType = document.createElement('div');
  exhibitorType.className = 'infoRow';

  exhibitorType.appendChild(exhibitorTypeTitle);
  exhibitorType.appendChild(exhibitorTypeInfo);

  /**
   * Other exhibitors
   * @type {HTMLDivElement}
   */
  let otherExhibitorsTitle = document.createElement('div');
  otherExhibitorsTitle.className = 'infoTitle';
  otherExhibitorsTitle.id = 'otherExhibitorsTitle';
  otherExhibitorsTitle.innerHTML = lang['printOtherExhibitors'];

  let otherExhibitorsInfo = document.createElement('div');
  otherExhibitorsInfo.className = 'info';
  otherExhibitorsInfo.id = 'otherExhibitorsInfo';
  if (contextEntries.length > 1) {
    for (let i = 1; i < contextEntries.length; i++) {
      otherExhibitorsInfo.innerHTML += contextEntries[i].querySelector('.exhibitorName').innerText + ' (' + contextEntries[i].querySelector('.exhibitorType').innerText + ')';
      if (i - 1 < contextEntries.length) {
        otherExhibitorsInfo.innerHTML += '<br />';
      }
    }
  } else {
    otherExhibitorsInfo.innerHTML = '---';
  }

  let otherExhibitors = document.createElement('div');
  otherExhibitors.className = 'infoRow';

  otherExhibitors.appendChild(otherExhibitorsTitle);
  otherExhibitors.appendChild(otherExhibitorsInfo);

  /**
   * Info Container
   * @type {HTMLDivElement}
   */
  let infoContainer = document.createElement('div');
  infoContainer.className = 'infoContainer';
  infoContainer.id = 'infoContainer';

  infoContainer.appendChild(booth);
  infoContainer.appendChild(exhibitor);
  infoContainer.appendChild(billing);
  infoContainer.appendChild(exhibitorType);
  infoContainer.appendChild(otherExhibitors);

  let canvasDiv = document.createElement('div');
  canvasDiv.className = 'screenshot';
  canvasDiv.id = 'screenshot';

  let container = document.createElement('div');
  container.className = 'printContainer';
  container.id = 'printContainer';

  container.appendChild(exhibitionLogoLong);
  container.appendChild(exhibitionLogoShort);
  container.appendChild(poweredBy);
  container.appendChild(headerContainer);
  container.appendChild(infoContainer);
  container.appendChild(canvasDiv);

  let captureScreenshot = document.getElementById('control-screenshot');
  captureScreenshot.appendChild(container);
}

/**
 * @param {string} exhibitionId
 * @param {string} quotelineId
 * @param {string} fileKey
 * @param {string} fairground
 * @param {string | null} lang
 * @return {Promise<Blob>}
 */
export async function printPdf(exhibitionId, quotelineId, fileKey, fairground, lang) {
  if (exhibitionId !== null && fileKey !== null) {
    lang === null ? lang = 'DE' : lang;

    const pdfFetch = await fetch('system/flayrPdfUmleitung.php', {
      method: 'POST',
      credentials: 'same-origin',
      headers: new Headers(),
      body: 'QuotelineId=' + quotelineId + '&FileKey=' + fileKey +'&Language=' + lang + '&ExhibitionId=' + exhibitionId + '&fairground=' + fairground,
    });

    if (pdfFetch.ok) {
      return await pdfFetch.blob();
    }
  }
}
